<ng-container *ngTemplateOutlet="isPreautorisationDisabled ? disabled : enabled"> </ng-container>

<!-- PRÉAUTORISATION DÉSACTIVÉE -->
<ng-template #disabled>
  <dsd-alert class="alert-no-margin-bottom" variant="inactive">
    {{ 'preautorisation-en-ligne.dashboard-card-status.disabled.texte' | translate }}
  </dsd-alert>
</ng-template>

<!-- PREAUTORISATION ACTIVÉE -->
<ng-template #enabled>
  <div [attr.data-cy]="'preautorisation_' + (statutPreautorisation$ | async | lowercase)">
    <ng-container [ngSwitch]="statutPreautorisation$ | async">
      <ng-container *ngSwitchCase="StatusPreautorisation.Acceptee" [ngTemplateOutlet]="acceptee"></ng-container>
      <ng-container
        *ngSwitchCase="StatusPreautorisation.ContreOffreAcceptee"
        [ngTemplateOutlet]="acceptee"
      ></ng-container>
      <ng-container
        *ngSwitchCase="StatusPreautorisation.ContreOffreRefusee"
        [ngTemplateOutlet]="contreOffreRefusee"
      ></ng-container>
      <ng-container *ngSwitchCase="StatusPreautorisation.RefuseeSimplifie" [ngTemplateOutlet]="refusee"></ng-container>
      <ng-container *ngSwitchCase="StatusPreautorisation.EnAttente" [ngTemplateOutlet]="enTraitement"></ng-container>
      <ng-container
        *ngSwitchCase="StatusPreautorisation.ContreOffreEnAttente"
        [ngTemplateOutlet]="contreOffreEnAttente"
      ></ng-container>
      <ng-container
        *ngSwitchCase="StatusPreautorisation.EnAttenteCoemprunteur"
        [ngTemplateOutlet]="enAttenteCoemprunteur"
      ></ng-container>
      <ng-container
        *ngSwitchCase="StatusPreautorisation.EnAttenteTaux"
        [ngTemplateOutlet]="enTraitement"
      ></ng-container>
      <ng-container
        *ngSwitchCase="StatusPreautorisation.EnAttenteSelectionTaux"
        [ngTemplateOutlet]="selectionTaux"
      ></ng-container>
      <ng-container *ngSwitchDefault [ngTemplateOutlet]="default"></ng-container>
    </ng-container>
  </div>
</ng-template>

<!-- ÉTAT SANS PREAUTORISATON - DÉFAUT -->
<ng-template #default>
  <div class="preautorisation-default" data-cy="preautorisation_default">
    <dsd-tag
      class="tag"
      [srOnlyIcon]="'preautorisation-en-ligne.dashboard-card-status.default.temps-sr-icon' | translate"
      icon-name="contenus_contour_temps"
    >
      <span>{{ 'preautorisation-en-ligne.dashboard-card-status.default.temps' | translate }}</span>
    </dsd-tag>
    <p
      class="texte"
      [innerHTML]="'preautorisation-en-ligne.dashboard-card-status.default.texte.' + typeProjet | translate"
    ></p>
    <dsd-button
      class="dsd-d-block"
      variant="primary"
      full-width="xs"
      (dsdButtonClick)="navigatePageAccueil()"
      data-cy="btn_preautorisation"
    >
      {{ 'preautorisation-en-ligne.dashboard-card-status.default.btn-obtenir' | translate }}
    </dsd-button>
    <dsd-button
      full-width="xs"
      (dsdButtonClick)="navigatePageInvitation()"
      class="btn-code-invitation"
      data-cy="btn_code_invitation"
    >
      {{ 'preautorisation-en-ligne.dashboard-card-status.default.btn-code-invitation' | translate }}
    </dsd-button>
  </div>
</ng-template>

<!-- PREAUTORISATION ACCEPTEE -->
<ng-template #acceptee>
  <dsd-alert *ngIf="isDateExpiringSoon(dateExpirationTaux$ | async)" data-cy="rappel_echeance_taux">
    {{
      'preautorisation-en-ligne.dashboard-card-status.acceptee.rappel-taux'
        | translate: { date: dateExpirationTaux$ | async | date }
    }}
  </dsd-alert>
  <dsd-alert *ngIf="isDateExpiringSoon(dateExpirationPreaut$ | async)" data-cy="rappel_echeance_preaut">
    {{
      'preautorisation-en-ligne.dashboard-card-status.acceptee.rappel-preaut'
        | translate: { date: dateExpirationPreaut$ | async | date }
    }}
  </dsd-alert>
  <p class="dsd-mb-md">{{ 'preautorisation-en-ligne.dashboard-card-status.acceptee.intro' | translate }}</p>
  <app-card theme="turquoise" class="dsd-mb-md">
    <h3 header class="dsd-t-5 dsd-mb-0" data-cy="title">
      {{ 'preautorisation-en-ligne.dashboard-card-status.acceptee.titre' | translate }}
    </h3>
    <div class="dsd-d-flex" data-cy="content">
      <span class="dsd-t-1 dsd-mb-0 dsd-fw-bold" data-cy="montant_preautorise">
        {{ montantPreautorise$ | async | desjardinsCurrency }}
      </span>
    </div>
    <p class="dsd-mb-0">
      {{ 'preautorisation-en-ligne.dashboard-card-status.acceptee.texte' | translate }}
      <strong data-cy="date_expiration">{{ dateExpirationPreaut$ | async | date }}</strong
      >.
    </p>
  </app-card>
  <ng-container *ngTemplateOutlet="actions"> </ng-container>
</ng-template>

<!-- PREAUTORISATION REFUSEE -->
<ng-template #refusee>
  <app-card theme="turquoise" class="dsd-mb-md">
    <h3 header class="dsd-t-5 dsd-mb-0" data-cy="title">
      {{ 'preautorisation-en-ligne.dashboard-card-status.refusee.titre' | translate }}
    </h3>
    <p data-cy="content">{{ 'preautorisation-en-ligne.dashboard-card-status.refusee.texte' | translate }}</p>
    <app-boite-contact isDSD="true" buttonStyle="textAndIcon"></app-boite-contact>
  </app-card>
  <ng-container *ngTemplateOutlet="actions"> </ng-container>
</ng-template>

<!-- PREAUTORISATION CONTRE-OFFRE REFUSEE -->
<ng-template #contreOffreRefusee>
  <app-card theme="turquoise" class="dsd-mb-md">
    <h3 header class="dsd-t-5 dsd-mb-0" data-cy="title">
      {{
        'preautorisation-en-ligne.dashboard-card-status.contre-offre-refusee.' +
          ((typeEmprunteur$ | async) === TypeEmprunteurEnum.Coemprunteur1 ? 'titre-refus-par-coemprunteur' : 'titre')
          | translate: { montantContreOffre: montantPropose$ | async | desjardinsCurrency }
      }}
    </h3>
    <p data-cy="content">
      {{ 'preautorisation-en-ligne.dashboard-card-status.contre-offre-refusee.texte' | translate }}
    </p>
    <app-boite-contact isDSD="true" buttonStyle="textAndIcon"></app-boite-contact>
  </app-card>
  <app-boite-annulation></app-boite-annulation>
</ng-template>

<!-- PREAUTORISATION SELECTION TAUX -->
<ng-template #selectionTaux>
  <app-card theme="turquoise" class="dsd-mb-md">
    <h3 header class="dsd-t-5 dsd-mb-0" data-cy="title">
      {{ 'preautorisation-en-ligne.dashboard-card-status.selection-taux.titre' | translate }}
    </h3>
    <div data-cy="content">
      <p
        [innerHTML]="
          'preautorisation-en-ligne.dashboard-card-status.selection-taux.texte' + getTexteEnAttenteSelectionTaux()
            | translate
              : {
                  date: dateExpirationSelectionTaux$ | async | date,
                  hourFloorMinute: dateExpirationSelectionTaux$ | async | hourFloorMinute
                }
        "
      ></p>
      <p class="dsd-mb-0">
        {{ 'preautorisation-en-ligne.dashboard-card-status.selection-taux.texte-2' | translate }}
      </p>
    </div>
  </app-card>
  <dsd-button
    *ngIf="!(isCoemprunteur$ | async) || (isEmprunteurSecondaire$ | async)"
    variant="primary"
    full-width="xs"
    (dsdButtonClick)="navigatePageResultat()"
    data-cy="btn_choisir_taux"
    class="dsd-mb-md"
  >
    {{ 'preautorisation-en-ligne.dashboard-card-status.selection-taux.btn-choisir' | translate }}
  </dsd-button>
  <app-boite-annulation></app-boite-annulation
></ng-template>

<!-- PREAUTORISATION EN TRAITEMENT -->
<ng-template #enTraitement>
  <app-card theme="graphite">
    <h3 header class="dsd-t-5 dsd-mb-0" data-cy="title">
      {{ 'preautorisation-en-ligne.dashboard-card-status.en-traitement.titre' | translate }}
    </h3>
    <p>{{ 'preautorisation-en-ligne.dashboard-card-status.en-traitement.texte' | translate }}</p>
    <p class="dsd-mb-0" data-cy="content">
      {{ 'preautorisation-en-ligne.dashboard-card-status.en-traitement.click-to-call.texte' | translate }}
      <app-boite-contact
        isDSD="true"
        buttonStyle="textOnly"
        buttonText="preautorisation-en-ligne.dashboard-card-status.en-traitement.click-to-call.lien"
      ></app-boite-contact>
    </p>
  </app-card>
</ng-template>

<!-- PREAUTORISATION EN ATTENTE COEMPRUNTEUR -->
<ng-template #enAttenteCoemprunteur>
  <app-card theme="turquoise" class="dsd-mb-md">
    <h3 header class="dsd-t-5 dsd-mb-0" data-cy="title">
      {{ 'preautorisation-en-ligne.dashboard-card-status.en-attente-coemprunteur.titre' | translate }}
    </h3>
    <p
      class="dsd-mb-0"
      data-cy="content"
      [innerHTML]="
        'preautorisation-en-ligne.dashboard-card-status.en-attente-coemprunteur.texte'
          | translate
            : {
                date: dateExpirationCodeInvitation$ | async | date,
                heure: dateExpirationCodeInvitation$ | async | hour,
                codeInvitation: codeInvitation$ | async
              }
      "
    ></p>
  </app-card>
  <ng-container *ngTemplateOutlet="actions"> </ng-container>
</ng-template>

<!-- PREAUTORISATION CONTRE-OFFRE EN ATTENTE -->
<ng-template #contreOffreEnAttente>
  <ng-container *ngIf="(typeEmprunteur$ | async) !== TypeEmprunteurEnum.Coemprunteur1">
    <dsd-tag
      class="dsd-mb-sm"
      theme="information"
      [srOnlyIcon]="
        'preautorisation-en-ligne.dashboard-card-status.contre-offre-en-attente.etiquette.sr-only-icon' | translate
      "
    >
      {{ 'preautorisation-en-ligne.dashboard-card-status.contre-offre-en-attente.etiquette.texte' | translate }}
    </dsd-tag>
    <p>{{ 'preautorisation-en-ligne.dashboard-card-status.contre-offre-en-attente.intro-texte' | translate }}</p>
    <app-card theme="turquoise" class="dsd-mb-md">
      <h3 header class="dsd-t-5 dsd-mb-0" data-cy="title">
        {{ 'preautorisation-en-ligne.dashboard-card-status.contre-offre-en-attente.titre' | translate }}
      </h3>
      <div class="dsd-d-flex dsd-b-40 dsd-mb-0">
        <span class="dsd-t-1 dsd-fw-bold mb-8" data-cy="montant_propose">
          {{ montantPropose$ | async | desjardinsCurrency }}
        </span>
      </div>
      <p
        class="dsd-mb-0"
        data-cy="content"
        [innerHTML]="
          'preautorisation-en-ligne.dashboard-card-status.contre-offre-en-attente.expiration'
            | translate: { dateExpiration: dateAnnulationContreOffre$ | async | date }
            | keepHtml
        "
      ></p>
    </app-card>
    <app-card theme="graphite" class="dsd-mb-md">
      <h3
        header
        class="dsd-t-5 dsd-mb-0"
        data-cy="title"
        [innerHTML]="
          'preautorisation-en-ligne.dashboard-card-status.contre-offre-en-attente.preautorisation-demandee' | translate
        "
      ></h3>
      <span class="dsd-t-1 dsd-fw-bold dsd-mb-0" data-cy="montant_demandee">
        {{ montantDemande$ | async | desjardinsCurrency }}
      </span>
    </app-card>

    <dsd-button
      variant="primary"
      full-width="xs"
      (dsdButtonClick)="navigatePageResultat()"
      class="dsd-mb-md"
      data-cy="btn_voir_details"
    >
      <span>
        {{ 'preautorisation-en-ligne.dashboard-card-status.contre-offre-en-attente.btn-consulter' | translate }}
      </span>
    </dsd-button>
    <app-boite-annulation></app-boite-annulation>
  </ng-container>
  <ng-container *ngIf="(typeEmprunteur$ | async) === TypeEmprunteurEnum.Coemprunteur1">
    <app-card theme="turquoise" class="dsd-mb-md">
      <h3 header class="dsd-t-5 dsd-mb-0" data-cy="title">
        {{
          'preautorisation-en-ligne.dashboard-card-status.contre-offre-en-attente.coemprunteur-principal.titre'
            | translate
        }}
      </h3>
      <p
        data-cy="content"
        [innerHTML]="
          'preautorisation-en-ligne.dashboard-card-status.contre-offre-en-attente.coemprunteur-principal.texte-1'
            | translate
              : {
                  date: dateAnnulationContreOffre$ | async | date,
                  hour: dateAnnulationContreOffre$ | async | hour
                }
            | keepHtml
        "
      ></p>
      <p class="dsd-mb-0">
        {{
          'preautorisation-en-ligne.dashboard-card-status.contre-offre-en-attente.coemprunteur-principal.texte-2'
            | translate
        }}
      </p>
    </app-card>
    <app-boite-annulation></app-boite-annulation>
  </ng-container>
</ng-template>

<ng-template #actions>
  <dsd-button
    variant="primary"
    full-width="xs"
    (dsdButtonClick)="navigatePageResultat()"
    class="dsd-mb-md"
    data-cy="btn_voir_details"
  >
    <span aria-hidden="true">{{ 'preautorisation-en-ligne.dashboard-card-status.btn-details' | translate }}</span>
    <span class="dsd-sr-only"
      >{{ 'preautorisation-en-ligne.dashboard-card-status.btn-details-sr-only' | translate }}
    </span>
  </dsd-button>
  <app-boite-annulation></app-boite-annulation>
</ng-template>
